import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=3a667300&lang=pug"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a667300')) {
      api.createRecord('3a667300', component.options)
    } else {
      api.reload('3a667300', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=3a667300&lang=pug", function () {
      api.rerender('3a667300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/stocks/feeding-programs/categories/Create.vue"
export default component.exports